// const deriveUrl = "http://192.168.1.121:8180"
const deriveUrl = "http://106.14.116.182:8081"
export default {
    deriveUrl
};



// WEBPACK FOOTER //
// ./src/api/derive/derive.js